/**
 * Retreives properties pins and adds them to the map
 * @param resultsPropertyPinLayer     the layer containing properties already added
 * @param backgroundPropertyPinLayer  the BackgroundPropertyPinLayer to add the properties too
 */
define(['jquery', 'c21/ajax', 'c21/maps/PinData'], function ($, ajax, PinData) {
   "use strict";

   return function (resultsPropertyPinLayer, backgroundPropertyPinLayer) {
      var self = this,
         m_xhr,
         addData = function (aLocation) {
            if (backgroundPropertyPinLayer) {
               backgroundPropertyPinLayer.setProperties(aLocation);
            }
         };

      self.getData = function (bounds, options) {
         m_xhr = ajax.fetch({
            cache: false,
            dataType: "json",
            data: $.extend({
               xy: bounds.xy,
               mx: bounds.mx,
               my: bounds.my,
               xx: bounds.xx
            }, options.refine),
            url: "/csjson/propertysearchgeo",
            success: function (data) {
               var aPropertyPinExtra = [],
                  aResultPropertyPins = resultsPropertyPinLayer.getProperties();

               $.each(data.points, function (i, propInfo) {
                  var iLat = propInfo[0],
                     iLon = propInfo[1],
                     strLid = propInfo[2],
                     pinData = new PinData(strLid, iLat, iLon);

                  var bAlreadyAdded = false;

                  // TODO: Use hashmap instead of a loop
                  if (aResultPropertyPins) {
                     $.each(aResultPropertyPins, function (i, propertyPin) {
                        if (propertyPin.getId() === strLid) {
                           bAlreadyAdded = true;
                           return false;
                        }
                     });
                  }

                  if (!bAlreadyAdded) {
                     aPropertyPinExtra.push(pinData);
                  }
               });

               addData(aPropertyPinExtra);
            },
            error: function (jqXHR, textStatus, errorThrown) {
               // We don't care about 'abort' errors, as those are purposeful
               if (textStatus === 'abort') {
                  return;
               }

               // Disabled per AF
               //alert('An error has occurred while loading property pins. The page needs reloaded');
               //window.location.reload();
            }
         });
      };

      self.cancel = function () {
         if (m_xhr) {
            m_xhr.abort();
         }
      };
   };
});
